import React from 'react';

const GamesPrinciplesSection = ({ principles }) => {
  return (
    <section aria-labelledby="games-principles-title" className="mb-20">
      <div className="max-w-2xl mx-auto text-center">
        <h2
          id="games-principles-title"
          className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
        >
          Como eu penso essa area
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Mesmo sendo um laboratorio com jogos e curiosidades, a proposta segue objetiva e
          organizada.
        </p>
      </div>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        {principles.map((item) => (
          <div
            key={item.id}
            className="bg-gradient-to-br from-slate-50 via-white to-blue-50 p-6 rounded-xl border border-slate-200 shadow-lg site-card shadow-slate-200/70 transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-slate-200/80"
          >
            <h3 className="text-xl font-semibold text-gray-900">{item.title}</h3>
            <p className="mt-3 text-gray-600">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GamesPrinciplesSection;
